// extracted by mini-css-extract-plugin
export default {"root":"ReportsRoot_root__KJgXN","emptyWarn":"ReportsRoot_emptyWarn__Gy2JX","placeHolderShimmer":"ReportsRoot_placeHolderShimmer__C6NV4"};